var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.question.cssClasses.videoContainer },
    [
      _c("sv-action", { attrs: { item: _vm.question.changeCameraAction } }),
      _vm._v(" "),
      _c("sv-action", { attrs: { item: _vm.question.closeCameraAction } }),
      _vm._v(" "),
      _c("video", {
        class: _vm.question.cssClasses.video,
        attrs: { autoplay: "", playsinline: "", id: _vm.question.videoId },
      }),
      _vm._v(" "),
      _c("sv-action", { attrs: { item: _vm.question.takePictureAction } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }